import { render, staticRenderFns } from "./TabsContentItem.vue?vue&type=template&id=bdd1e230&scoped=true"
import script from "./TabsContentItem.vue?vue&type=script&lang=js"
export * from "./TabsContentItem.vue?vue&type=script&lang=js"
import style0 from "./TabsContentItem.vue?vue&type=style&index=0&id=bdd1e230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1e230",
  null
  
)

export default component.exports